import { useDebugValue, useEffect, useRef } from 'react';
export function useResourceDebug({ state, shouldWait, name = 'unknown', key, enableLog, }) {
    let value = getResourceState(state, shouldWait);
    const prevValue = useRef();
    useEffect(() => {
        if (process.env.NODE_ENV === 'development' && enableLog) {
            const prev = prevValue.current;
            console.group('Resource: ' + name + ', key: ' + key);
            console.log('state: ', prev ? `${prev} => ${value}` : value);
            console.groupEnd();
        }
        prevValue.current = value;
    }, [value]);
    useDebugValue(value);
}
function getResourceState({ loading, resolved, invalidated, error }, shouldWait) {
    if (shouldWait) {
        return 'waiting';
    }
    if (loading) {
        return 'loading';
    }
    if (invalidated) {
        return 'invalidated';
    }
    if (error) {
        return 'errored';
    }
    if (resolved) {
        return 'resolved';
    }
    return 'unknown';
}
//# sourceMappingURL=useResourceDebug.js.map